import { Text } from '@Components/Text';
import styled from 'styled-components';

export const ContainerPassword = styled.div`
	min-width: 490px;
`;

export const ContainerIcon = styled.div`
	position: absolute;
	top: 1.143rem;
	right: 3.4rem;
	z-index: 5;
	width: 1.357rem;
	height: 1.357rem;
	border-radius: 50%;
	border: 2px solid;
	border-color: #f1416c;
	margin-right: '0.857rem';
`;

export const Label = styled(Text).attrs({
	weight: 'extra-bold',
})`
	:after {
		content: '*';
		color: red;
	}
`;

export const TextMuted = styled(Text)`
	color: #7e8299;
`;

export const ContainerDiv = styled.div`
	width: 490px;
`;
